import {
  FETCH_USER_EVENTS_SUCCESS,
  FETCH_USER_EVENTS_ASYNC_END,
  FETCH_USER_EVENTS_ASYNC_START,
} from '../actions/actions'

import {
  FETCH_BOUGHT_EVENTS_SUCCESS,
  FETCH_BOUGHT_EVENTS_ASYNC_START,
  FETCH_BOUGHT_EVENTS_ASYNC_END,
} from '../actions/actions'

import dotProp from 'dot-prop-immutable-chain'

export function myEventsListOld(state = {}, action) {
  switch (action.type) {
    case FETCH_USER_EVENTS_ASYNC_START:
      return dotProp(state)
        .set('aSyncCall', true)
        .value()

    case FETCH_USER_EVENTS_ASYNC_END:
      return dotProp(state)
        .set('aSyncCall', false)
        .value()

    case FETCH_USER_EVENTS_SUCCESS:
      return { ...state, ...action.ticket_orders }

    // because of a limitation from server, the response of
    // creating a new ticket_order does not contain the enough data about
    // owners, so this action is ignored altogether, and a fetch
    // user events action is dispatched instead

    // case CREATE_EVENT_TICKET_ORDER_SUCCESS:
    //   const boughtTicketOrder = action.ticket_order;
    //   const service = boughtTicketOrder.service;
    //   const owners = boughtTicketOrder.owners;
    //   boughtTicketOrder.service = service.id
    //   boughtTicketOrder.owners = service.id
    //   return dotProp(state)
    //     .set(`entities.ticket_orders.${boughtTicketOrder.id}`, action.ticket_order)
    //     .set(`entities.services.${service.id}`, service)
    //     .set("result", result => [...result, boughtTicketOrder.id])
    //     .value();

    default:
      return state
  }
}

export default function myEventsList(state = {}, action) {
  switch (action.type) {
    case FETCH_BOUGHT_EVENTS_ASYNC_START:
      return dotProp(state)
        .set('aSyncCall', true)
        .value()

    case FETCH_BOUGHT_EVENTS_ASYNC_END:
      return dotProp(state)
        .set('aSyncCall', false)
        .value()

    case FETCH_BOUGHT_EVENTS_SUCCESS:
      return { ...state, ...action.events }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/myEventsList.js